import { BaseAPI } from "../../BaseAPI";
import { v4 as uuidv4 } from 'uuid';
import * as environment from '../../../config/environment';
 
 
class SifremiUnuttumAPI extends BaseAPI {
 
 
  constructor () {
    const baseUrl = environment.API_URL + "SmsDogrulamaReference/SendSms";
    super(baseUrl);
  }
 
 
  SendSms(request: SmsDogrulamaRequest){
    return this.post("", request, true);
   
  }
 
}
export default new SifremiUnuttumAPI();
class SmsDogrulamaRequest {
    cepTelefonNo?: string;
    referansNo?: string;
    tcKimlikNo?: string;
    vergiNo?: string;
    sicilNo?: number;
    aboneNo?: number;
    token?:string;
    isResend?:boolean;
    isMail?: boolean;
 
    constructor(
        cepTelefonNo?: string,
        tcKimlikNo?: string,
        vergiNo?: string,
        sicilNo?: number,
        aboneNo?: number,
        token?:string,
        isResend?:boolean,
        isMail: boolean =false
    ) {
        let uniqueId = uuidv4();
        this.cepTelefonNo = cepTelefonNo;
        this.referansNo = uniqueId;
        this.tcKimlikNo = tcKimlikNo;
        this.vergiNo = vergiNo;
        this.sicilNo = sicilNo;
        this.aboneNo = aboneNo;
        this.token=token;
        this.isResend=isResend;
        this.isMail= isMail;
    }
}
export { SmsDogrulamaRequest };